module.exports = __webpack_public_path__ + "img/add-folder.d06c5ad0.svg";